import React, { useEffect, useRef } from "react";
import * as bootstrap from "bootstrap";

const HomeCarousel: React.FC = () => {
  const carouselRef = useRef<HTMLDivElement>(null);

  // ============================================================
  // BANNERS
  // ============================================================

  const banners = [
    {
      image: "https://www.growniverse.com/images//home-banner4.webp",
      alt: "Growniverse education banner",
    },
    {
      image: "https://www.growniverse.com/images//home-banner9.webp",
      alt: "Growniverse learning banner",
    },
    {
      image: "https://www.growniverse.com/images//home-banner2.webp",
      alt: "Growniverse education banner",
    },
    {
      image: "https://www.growniverse.com/images//home-banner3.webp",
      alt: "Growniverse learning banner",
    },
    {
      image: "https://www.growniverse.com/images//home-banner7.webp",
      alt: "Growniverse education banner",
    },
    {
      image: "https://www.growniverse.com/images//home-banner8.webp",
      alt: "Growniverse learning banner",
    },
    {
      image: "https://www.growniverse.com/images//home-banner6.webp",
      alt: "Growniverse education banner",
    },
    {
      image: "https://www.growniverse.com/images//home-banner5.webp",
      alt: "Growniverse learning banner",
    },
  ];

  // ============================================================
  // BOOTSTRAP CAROUSEL
  // ============================================================

  useEffect(() => {
    if (!carouselRef.current) return;

    const carousel = new bootstrap.Carousel(
      carouselRef.current,
      {
        interval: 3500,
        ride: "carousel",
        pause: false,
        wrap: true,
        touch: true,
      }
    );

    return () => {
      carousel.dispose();
    };
  }, []);

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <>
      <section className="growniverse-home-carousel-wrapper">

        <div
          id="homeCarousel"
          ref={carouselRef}
          className="carousel slide carousel-fade growniverse-home-carousel"
          data-bs-ride="carousel"
        >

          {/* ====================================================
              SLIDES
          ==================================================== */}

          <div className="carousel-inner growniverse-carousel-inner">

            {banners.map((banner, index) => (

              <div
                key={banner.image}
                className={`carousel-item ${
                  index === 0 ? "active" : ""
                }`}
              >

                {/* ==================================================
                    IMAGE
                ================================================== */}

                <img
                  src={banner.image}
                  alt={banner.alt}
                  className="growniverse-banner-image"
                />


                {/* ==================================================
                    DARK OVERLAY
                ================================================== */}

                <div className="growniverse-banner-dark" />


                {/* ==================================================
                    HERO CONTENT
                ================================================== */}

                <div className="growniverse-hero-content">

                  <h1 className="growniverse-hero-title">

                    Best Education

                    <br />

                    <span>
                      From Your Home
                    </span>

                  </h1>


                  <p className="growniverse-hero-description">

                    Don't change your learning,

                    <br />

                    just change the way.

                  </p>

                </div>

              </div>

            ))}

          </div>


          {/* ====================================================
              PREVIOUS BUTTON
          ==================================================== */}

          <button
            className="growniverse-carousel-prev"
            type="button"
            data-bs-target="#homeCarousel"
            data-bs-slide="prev"
            aria-label="Previous slide"
          >

            <span aria-hidden="true">
              ‹
            </span>

          </button>


          {/* ====================================================
              NEXT BUTTON
          ==================================================== */}

          <button
            className="growniverse-carousel-next"
            type="button"
            data-bs-target="#homeCarousel"
            data-bs-slide="next"
            aria-label="Next slide"
          >

            <span aria-hidden="true">
              ›
            </span>

          </button>


          {/* ====================================================
              INDICATORS
          ==================================================== */}

          <div className="growniverse-carousel-indicators">

            {banners.map((_, index) => (

              <button
                key={index}
                type="button"
                data-bs-target="#homeCarousel"
                data-bs-slide-to={index}
                className={
                  index === 0
                    ? "active"
                    : ""
                }
                aria-current={
                  index === 0
                    ? "true"
                    : undefined
                }
                aria-label={`Slide ${index + 1}`}
              />

            ))}

          </div>

        </div>

      </section>


      {/* ========================================================
          CSS
      ======================================================== */}

      <style>
        {`

/* ============================================================
   MAIN WRAPPER
============================================================ */

.growniverse-home-carousel-wrapper {
  position: relative;

  width: 100vw;

  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);

  margin-top: 0;
  margin-bottom: 0;

  padding: 0;

  overflow: hidden;

  background: #05070b;

  border: 0;

  outline: none;
}


/* ============================================================
   MAIN CAROUSEL
============================================================ */

.growniverse-home-carousel {
  position: relative;

  width: 100%;

  height: 620px;

  margin: 0;
  padding: 0;

  overflow: hidden;

  background: #05070b;

  border: 0;

  outline: none;
}


/* ============================================================
   CAROUSEL INNER
============================================================ */

.growniverse-carousel-inner {
  width: 100%;

  height: 100%;

  margin: 0;
  padding: 0;

  border: 0;

  outline: none;
}


/* ============================================================
   SLIDE
============================================================ */

.growniverse-home-carousel .carousel-item {
  position: relative;

  width: 100%;

  height: 620px;

  margin: 0;
  padding: 0;

  overflow: hidden;

  background: #05070b;

  border: 0;

  outline: none;
}


/* ============================================================
   IMAGE
============================================================ */

.growniverse-banner-image {
  position: absolute;

  inset: 0;

  display: block;

  width: 100%;
  height: 100%;

  max-width: none;

  margin: 0;
  padding: 0;

  object-fit: cover;

  object-position: center center;

  border: 0;

  outline: none;

  filter: none;

  transform: none;
}


/* ============================================================
   DARK OVERLAY
============================================================ */

.growniverse-banner-dark {
  position: absolute;

  inset: 0;

  z-index: 1;

  pointer-events: none;

  background:
    linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.60) 0%,
      rgba(0, 0, 0, 0.30) 45%,
      rgba(0, 0, 0, 0.08) 100%
    );
}


/* ============================================================
   HERO CONTENT
============================================================ */

.growniverse-hero-content {
  position: absolute;

  z-index: 5;

  top: 50%;
  left: 50%;

  transform:
    translate(
      -50%,
      -50%
    );

  width: min(
    700px,
    90%
  );

  margin: 0;

  padding: 0;

  text-align: center;
}


/* ============================================================
   TITLE
============================================================ */

.growniverse-hero-title {
  margin: 0;

  padding: 0;

  color: #ffffff;

  font-size: clamp(
    38px,
    4.5vw,
    68px
  );

  line-height: 1.08;

  font-weight: 700;

  letter-spacing: -1px;

  text-align: center;

  text-shadow:
    0 5px 20px
    rgba(0, 0, 0, 0.65);
}


/* ============================================================
   TITLE SECOND LINE
============================================================ */

.growniverse-hero-title span {
  display: inline;

  margin: 0;

  padding: 0;

  color: #ffffff;

  background: none;

  -webkit-background-clip: initial;

  background-clip: initial;

  -webkit-text-fill-color: #ffffff;
}


/* ============================================================
   DESCRIPTION
============================================================ */

.growniverse-hero-description {
  margin: 24px 0 0;

  padding: 0;

  color:
    rgba(
      255,
      255,
      255,
      0.90
    );

  font-size: 18px;

  line-height: 1.7;

  font-weight: 400;

  text-align: center;

  text-shadow:
    0 3px 15px
    rgba(
      0,
      0,
      0,
      0.7
    );
}


/* ============================================================
   PREVIOUS / NEXT BUTTONS
============================================================ */

.growniverse-carousel-prev,
.growniverse-carousel-next {
  position: absolute;

  z-index: 10;

  top: 50%;

  transform:
    translateY(-50%);

  width: 48px;

  height: 48px;

  display: flex;

  align-items: center;

  justify-content: center;

  padding: 0;

  border:
    1px solid
    rgba(
      255,
      255,
      255,
      0.20
    );

  border-radius: 50%;

  background:
    rgba(
      0,
      0,
      0,
      0.25
    );

  color: #ffffff;

  cursor: pointer;

  transition:
    all 0.25s ease;
}


.growniverse-carousel-prev {
  left: 28px;
}


.growniverse-carousel-next {
  right: 28px;
}


.growniverse-carousel-prev span,
.growniverse-carousel-next span {
  font-size: 32px;

  line-height: 1;

  margin-top: -3px;
}


.growniverse-carousel-prev:hover,
.growniverse-carousel-next:hover {

  background:
    rgba(
      0,
      220,
      255,
      0.15
    );

  border-color:
    rgba(
      0,
      220,
      255,
      0.65
    );

  box-shadow:
    0 0 20px
    rgba(
      0,
      220,
      255,
      0.20
    );

  transform:
    translateY(-50%)
    scale(1.05);
}


/* ============================================================
   INDICATORS
============================================================ */

.growniverse-carousel-indicators {
  position: absolute;

  z-index: 20;

  left: 50%;

  bottom: 25px;

  transform:
    translateX(-50%);

  display: flex;

  align-items: center;

  justify-content: center;

  gap: 8px;

  width: auto;

  margin: 0;

  padding: 0;
}


.growniverse-carousel-indicators button {
  width: 28px;

  height: 3px;

  padding: 0;

  margin: 0;

  border: 0;

  border-radius: 10px;

  background:
    rgba(
      255,
      255,
      255,
      0.45
    );

  opacity: 1;

  transition:
    all 0.3s ease;
}


.growniverse-carousel-indicators button.active {

  width: 55px;

  background: #00d9ff;

  box-shadow:
    0 0 10px
    rgba(
      0,
      217,
      255,
      0.55
    );
}


/* ============================================================
   LARGE DESKTOP
============================================================ */

@media (min-width: 1200px) {

  .growniverse-home-carousel {

    height: 680px;

  }


  .growniverse-home-carousel
  .carousel-item {

    height: 680px;

  }

}


/* ============================================================
   TABLET
============================================================ */

@media (max-width: 991px) {

  .growniverse-home-carousel {

    height: 560px;

  }


  .growniverse-home-carousel
  .carousel-item {

    height: 560px;

  }


  .growniverse-hero-content {

    width: 85%;

  }


  .growniverse-hero-title {

    font-size: 46px;

  }


  .growniverse-hero-description {

    font-size: 16px;

  }

}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 767px) {

  /* ----------------------------------------------------------
     FULL EDGE-TO-EDGE MOBILE
  ---------------------------------------------------------- */

  .growniverse-home-carousel-wrapper {

    width: 100vw;

    max-width: 100vw;

    margin: 0 !important;

    margin-left:
      calc(50% - 50vw) !important;

    margin-right:
      calc(50% - 50vw) !important;

    padding: 0 !important;

    border: 0 !important;

    outline: 0 !important;

    overflow: hidden;

  }


  .growniverse-home-carousel {

    width: 100vw;

    max-width: 100vw;

    height: 620px;

    min-height: 620px;

    margin: 0 !important;

    padding: 0 !important;

    border: 0 !important;

    outline: 0 !important;

    overflow: hidden;

  }


  .growniverse-carousel-inner {

    width: 100vw;

    height: 620px;

    margin: 0 !important;

    padding: 0 !important;

    border: 0 !important;

  }


  .growniverse-home-carousel
  .carousel-item {

    width: 100vw;

    height: 620px;

    min-height: 620px;

    margin: 0 !important;

    padding: 0 !important;

    border: 0 !important;

    overflow: hidden;

  }


  /* ----------------------------------------------------------
     MOBILE IMAGE

     FULL LEFT + RIGHT

     NO PADDING
     NO MARGIN
     NO BORDER
  ---------------------------------------------------------- */

  .growniverse-banner-image {

    position: absolute;

    inset: 0;

    width: 100vw;

    height: 100%;

    max-width: none;

    margin: 0 !important;

    padding: 0 !important;

    border: 0 !important;

    outline: 0 !important;

    object-fit: cover;

    object-position: center center;

    transform: none;

    filter: none;

  }


  /* ----------------------------------------------------------
     MOBILE OVERLAY
  ---------------------------------------------------------- */

  .growniverse-banner-dark {

    background:
      linear-gradient(
        90deg,
        rgba(0, 0, 0, 0.48),
        rgba(0, 0, 0, 0.18)
      );

  }


  /* ----------------------------------------------------------
     MOBILE CONTENT

     ONLY 5PX LEFT / RIGHT PADDING
  ---------------------------------------------------------- */

  .growniverse-hero-content {

    position: absolute;

    top: 50%;

    left: 50%;

    width: 100%;

    max-width: 100%;

    margin: 0;

    padding-left: 5px;

    padding-right: 5px;

    transform:
      translate(
        -50%,
        -50%
      );

    text-align: center;

  }


  .growniverse-hero-title {

    margin: 0;

    padding: 0;

    font-size:
      clamp(
        32px,
        9vw,
        46px
      );

    line-height: 1.10;

    letter-spacing: -0.8px;

    font-weight: 700;

    text-align: center;

  }


  .growniverse-hero-title span {

    display: inline;

    margin: 0;

    padding: 0;

    color: #ffffff;

    background: none;

    -webkit-text-fill-color:
      #ffffff;

  }


  .growniverse-hero-description {

    margin: 18px 0 0;

    padding: 0;

    font-size: 15px;

    line-height: 1.6;

    text-align: center;

  }


  /* ----------------------------------------------------------
     MOBILE ARROWS
  ---------------------------------------------------------- */

  .growniverse-carousel-prev,
  .growniverse-carousel-next {

    width: 34px;

    height: 34px;

    border: 0;

    background:
      rgba(
        0,
        0,
        0,
        0.20
      );

    box-shadow: none;

  }


  .growniverse-carousel-prev {

    left: 10px;

  }


  .growniverse-carousel-next {

    right: 10px;

  }


  .growniverse-carousel-prev span,
  .growniverse-carousel-next span {

    font-size: 27px;

  }


  /* ----------------------------------------------------------
     MOBILE INDICATORS
  ---------------------------------------------------------- */

  .growniverse-carousel-indicators {

    bottom: 18px;

    gap: 5px;

    margin: 0;

    padding: 0;

  }


  .growniverse-carousel-indicators button {

    width: 20px;

    height: 3px;

    margin: 0;

    padding: 0;

    border: 0;

  }


  .growniverse-carousel-indicators
  button.active {

    width: 35px;

  }

}


/* ============================================================
   VERY SMALL MOBILE
============================================================ */

@media (max-width: 400px) {

  .growniverse-home-carousel {

    height: 580px;

    min-height: 580px;

  }


  .growniverse-carousel-inner {

    height: 580px;

  }


  .growniverse-home-carousel
  .carousel-item {

    height: 580px;

    min-height: 580px;

  }


  .growniverse-banner-image {

    width: 100vw;

    height: 100%;

  }


  .growniverse-hero-content {

    width: 100%;

    padding-left: 5px;

    padding-right: 5px;

  }


  .growniverse-hero-title {

    font-size: 31px;

  }


  .growniverse-hero-description {

    font-size: 14px;

  }

}


/* ============================================================
   REMOVE ALL POSSIBLE IMAGE SPACING
============================================================ */

.growniverse-home-carousel img {

  margin: 0 !important;

  padding: 0 !important;

  border: 0 !important;

  outline: none !important;

}


/* ============================================================
   REMOVE BOTTOM / GRID LINES COMPLETELY
============================================================ */

.growniverse-banner-gradient,
.growniverse-banner-grid {


}


/* ============================================================
   NO HORIZONTAL SCROLL
============================================================ */

.growniverse-home-carousel-wrapper,
.growniverse-home-carousel,
.growniverse-carousel-inner,
.growniverse-home-carousel
.carousel-item {

  max-width: 100vw;

}

`}
      </style>
    </>
  );
};

export default HomeCarousel;